import { responsiveVariables } from "../../utilities/props.js";
import "./align.css";
const getAlignStyles = (value) => {
    if (!value)
        return null;
    return {
        variables: responsiveVariables("--rs-align", value),
    };
};
export default getAlignStyles;
